import { connect } from 'react-redux';
import { ContentState } from 'draft-js';
import React from 'react';

// Fp
import { DRAFT_TITLE_CHANGE, CREATE_PAGE, DRAFT_CONTENT_CHANGE } from '../../constants';
import ActionButton from '../ActionButton';
import BasePage from './BasePage';
import DraftEditor from './DraftEditor';

class Page extends React.Component {
  constructor(props) {
    super(props);
    this.onChange = (event) => this.props.onChange(event.target.value);
  }

  componentDidMount() {
    this.props.setDraftContent('Here is some content');
    this.props.setDraftTitle('')
    this.input.focus();
  }

  render() {
    const {title, onSave} = this.props;

    const titleInput = (
      <input
        type="text"
        placeholder="New Document"
        value={title}
        ref={(ref) => this.input = ref}
        onChange={this.onChange} />
    )

    const links = [
      <ActionButton onClick={onSave}>Save</ActionButton>
    ];

    return (
      <BasePage title={titleInput} links={links}>
        <DraftEditor />
      </BasePage>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    title: state.draft.title
  }
}


const mapDispatchToProps = (dispatch) => {
  return {
    setDraftContent: (content) => dispatch({ type: DRAFT_CONTENT_CHANGE, content: ContentState.createFromText(content) }),
    setDraftTitle: (title) => dispatch({ type: DRAFT_TITLE_CHANGE, title }),
    onChange: (title) => dispatch({ type: DRAFT_TITLE_CHANGE, title }),
    onSave: () => dispatch({ type: CREATE_PAGE })
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Page);



/** WEBPACK FOOTER **
 ** ./src/components/pages/New.js
 **/